/**
 * Styled Components - Created by cazarez on 14/05/18.
 */
import Icon from 'antd/lib/icon'
import TextArea from 'antd/lib/input/TextArea'
import styled from 'styled-components'
import Caroussel from 'react-slick'
import { BLACK_BG, WHITE } from '../../theme/colors'
import Modal from 'antd/lib/modal'
import Collapse from 'antd/lib/collapse'
import Input from 'antd/lib/input'

interface DivProps {
  secondary?: boolean
  preview?: boolean
  url?: string
  third?: boolean
}

export const buttonStyle = {
  backgroundColor: 'white',
  opacity: 0,
}

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  font-family: Avenir;
  color: rgb(54, 69, 79);
  font-family: "Avenir Next";
  #stepCardContainer {
    position: relative;
    width: 752px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    padding: 16px;
    @media (max-width: 698px) {
      width: 96%;
    }
    @media (max-width: 320px) {
      padding: 0;
    }
  }
  #fitsTitle {
    font-size: 18px;
    color: #000;
    text-align: center;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-top: 14px;
    margin: 4px 0 12px;
    @media (max-width: 698px) {
      font-size: 14px;
    }
  }
  #get-measured-title {
    width: 728px;
    color: #000;
    text-align: center;
    font-family: "Avenir Next";
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    &.before-your-scan {
      color: #302628;
      font-size: 28px;
      font-weight: 600;
      letter-spacing: -0.84px;
      @media (max-height: 832px) {
        margin-bottom: 6px;
      }
    }
    @media (max-width: 698px) {
      font-size: 14px;
      width: 346px;
    }
    @media (max-width: 320px) {
      font-size: 14px;
      width: 300px;
    }
  }
  #get-measured-sub-title {
    color: #302628;
    font-size: 14px;
    font-weight: 400;
    @media (max-width: 698px) {
      margin-inline: 16px;
      text-align: center;
    }
    @media (max-height: 832px) {
      margin-bottom: 0px;
    }
  }
  #design-bottom-actions {
    width: 60%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 28px 28px;
    @media (max-width: 698px) {
      width: 100%;
      position: fixed;
      bottom: 0;
      background: white;
      padding-top: 12px;
      z-index: 2;
      &.border-top {
        border-top: 1px solid #B3B3B3;
      }
    }
    @media (max-width: 320px) {
      padding: 14px 8px;
    }
  }
  .fit-preference-bottom-sections {
    justify-content: space-between; 
    margin: 16px 18px;
    width: 100%;
    @media (max-width: 698px) {
      position: fixed;
      bottom: 0;
      background: white;
      padding: 14px;
      z-index: 2;
      margin: 0;
      &.border-top {
        border-top: 1px solid #B3B3B3;
      }
    }
  }
`

export const HowItWorkContainer = styled.div`
  @media (max-width: 698px) {
    padding-bottom: 104px;
  }
  .section-title {
    text-align: center;
    font-family: Avenir;
    font-size: 18px;
    font-weight: bold;
    padding-top: 20px;  
    @media (max-width: 698px) {
      margin: 28px auto;
      color: #302628;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 28px;
      letter-spacing: 0.1px;
    }
    @media (max-width: 320px) {
      margin: 24px auto;
      font-size: 16px;
      line-height: 0px;
    }
  }
  .section-subtitle {
    width: 700px;
    padding: 0 16px;
    margin-top: 12px;
    text-align: center;
    color: #302628;
    font-family: Avenir;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0.1px;
    @media (max-width: 698px) {
      width: 390px;
      padding: 0 18px;
    }
    @media (max-width: 320px) {
      width: 100%;
      font-size: 12.5px;
      padding: 0 20px;
      line-height: 18px;
    }
  }
  .section-media-content {
    max-width: 800px;
    width: 100%;
    border-radius: 5px;
    object-fit: cover;
    margin: 20px;
    &.mobile {
      display: none;
    }
    @media (max-width: 698px) {
      width: 97%;
      height: auto;
      display: none;
      &.mobile {
        display: block;
      }
    }
    @media (max-width: 320px) {
      width: 94vw;
      margin: 20px 10px;
    }
  }
  #size-replacement-policy {
    max-width: 578px;
    display: inline-block;
    padding: 8px 16px;
    margin-bottom: 8px;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid #2196F3;
    background: rgba(33, 150, 243, 0.10);
    color: #302628;
    text-align: center;
    font-family: 14px "Avenir Next";
    span.underline {
      cursor: pointer;
      font-weight: 600;
      text-decoration-line: underline;
      text-underline-offset: 13%;
      text-underline-position: from-font;

      &::after {
        content: '';
        display: block;
      }

      @media (max-width: 698px) {
        display: inline-block;

        &::after {
          display: none;
        }
      }
    }
    @media (max-width: 698px) {
      align-self: stretch;
      max-width: none;
      padding: 8px;
      margin-inline: 18px;
      font-size: 12px;
      line-height: 20px;
      text-align: center;
    }
  }
  .section-footnote {
    padding-bottom: 10px;
    font-size: 14px;
    color: rgb(48, 38, 40);
    @media (max-width: 698px) {
      padding: 0 28px 16px 28px;
      font-size: 12px;
    }
    @media (max-width: 320px) {
      padding: unset;
      margin: 0px 16px;
      font-size: 12px;
    }
  }
  #policy {
    color: cornflowerblue;
    padding-bottom: 48px;
    cursor: pointer;
    @media (max-width: 698px) {
      padding-bottom: 80px;
    }
  }
`

export const FitProfilesList = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-block: 20px 60px;
  .fitCard {
    display: flex;
    flex-flow: column;
    padding: 22px;
    justify-content: center;
    align-items: center;
    background: #F7F7F7;
    max-width: 286px;
    width: 100%;
    border-radius: 8px;
    margin: 22px 12px;
    transition: box-shadow .25s;
    box-shadow: 0px 1px 3px 0px #d5d5d5;
    &:hover {
      cursor: pointer;
      box-shadow: 3px 5px 15px -2px #d5d5d5;
    }
    &.selected {
      outline: 3px solid #34C759;
    }
  }
  .avatar {
    font-size: 38px;
    color: white;
    border-radius: 50%;
    display: flex;
    height: 80px;
    width: 80px;
    align-items: center;
    justify-content: center;
    box-shadow: 6px 6px 30px #0000002e;
  }
  .name {
    margin-top: 16px;
    font-size: 18px;
    font-weight: 600;
  }
  .role {
    margin-top: 4px;
    text-transform: uppercase;
    font-weight: 500;
    color: #625F5F;
  }
  #emptyCard {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-height: 190px;
    border: 2px dashed #D7D1D2;
    border-radius: 6px;
    max-width: 286px;
    font-size: 16px;
    padding: 42px;
    text-align: center;
    font-weight: 500;
    color: #817E7E;
    background: white;
    margin: 22px 12px;
    cursor: pointer;
    transition: box-shadow .25s;
    box-shadow: 0px 1px 3px 0px #d5d5d5;
    &:hover {
      cursor: pointer;
      box-shadow: 3px 5px 15px -2px #d5d5d5;
    }
    .anticon {
      font-size: 40px;
      margin-bottom: 16px;
      border: 2px solid #a2a0a0;
      border-radius: 50px;
      padding: 12px;
    }
  }
  @media (max-width: 698px) {
    .fitCard {
      padding: 18px;
      margin: 12px;
    }
    .avatar {
      font-size: 26px;
      width: 64px;
      height: 64px;
    }
    .name {
      margin-top: 12px;
      font-size: 16px;
    }
  }
`

export const FitProfileLabel = styled.div`
  color: #302628;
  font-family: "Avenir Next";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  align-items: center;
  text-transform: capitalize;
  h6 {
    margin-bottom: 0;
    font-size: 14px;
    margin-right: 10px;
    font-weight: bold;
  }
`

export const FitProfileHeading = styled.div`
  color: #302628;
  font-family: "Avenir Next";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const FixedBar = styled.div`
  position: sticky;
  width: 100%;
  top: 0;
  background: white;
  padding-bottom: 6px;
  display: flex;
  flex-flow: column;
  align-items: center;
  z-index: 2;
  @media (max-width: 698px) {
    padding-bottom: 0px;
  }
  .headband {
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
    color: #000;
    font-family: "Avenir Next";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.1px;
    @media (max-width: 698px) {
      margin-bottom: 0px;
    }
  }
  .exit-icon {
    position: absolute;
    top: 2px;
    display: flex;
    align-items: center;
    color: #302628;
    cursor: pointer;
    font-size: 16px;
  }
  .exit-text {
    font-weight: 500;
    margin-left: 4px;
  }
  .progress-bar {
    display: flex;
    margin: 0px 12px;
    font-size: 12px;
    width: 72%;
    position: relative;
    @media (max-width: 698px) {
      display: none;
    }
  }
  #profileDiv {
    display: flex;
    align-self: center;
    align-items: center;
    position: absolute;
    right: 0;
    .anticon {
      color: white;
      background: #00C7BE;
      padding: 4px;
      border-radius: 50px;
      margin-right: 8px;
    }
  }
`

export const CarousselContainer = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-top: 40px;
  .muted-text {
    color: #A8A0A1;
    font-family: "Avenir Next";
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 8px;
    @media (max-height: 832px) {
      margin-bottom: 2px;
    }
  }
  .muted-text[data-has-error="true"] {
    color: #C91731;
  }
  .muted-text[data-has-error="false"] {
    color: #A8A0A1;
  }
  .carousel-bottom-actions {
    width: 90%;
    align-items: flex-end;
    justify-content: space-between;
    padding-block: 40px;
    @media (max-width: 698px) {
      width: 100%;
      padding: 10px 10px 16px 10px;
      position: fixed;
      bottom: 0px;
      height: unset;
      border-top: 1px solid #B3B3B3;
      background: white;
    }
    @media (max-height: 832px) {
      padding-top: 8px;
      padding-bottom: 16px;
    }
  }
  .get-measured-bottom-actions {
    @media (min-width: 699px) {
      position: sticky;
      bottom: 0;
      background: white;
      z-index: 1;
      border-top: 1px solid #B3B3B3;
    }
    @media (max-width: 698px) {
      flex-direction: column;
      align-items: center;
    }
  }
  .carousel-bottom-actions.get-measured-bottom-actions .bottom-actions-container .close {
    @media (max-width: 698px) {
      width: 90px !important;
    }
  }
  #manualBtn {
    max-width: 230px;
    margin-top: 8px;
    margin-right: 12px;
    text-decoration: underline;
    color: #302628;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    &:hover {
      cursor: pointer;
    }
    &[data-mobile="true"] {
      display: none;
    }
    &[data-mobile="false"] {
      max-width: 100%;
      margin-right: 22px;
      margin-bottom: 10px;
      font-size: 14px;
      @media (max-width: 320px) {
        margin-bottom: 0px;
      }
    }
  }
  #take-photos-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 698px) {
    padding-block: 20px 130px;
    width: 100%;
  }
  @media (max-height: 832px) {
    padding-top: 8px;
  }
`

export const CarousselDiv = styled(Caroussel)`
  display: inline-grid !important;
  margin-top: 20px;
  height: 400px;
  .slick-prev {
    left: 0px !important;
    z-index: 2;
  }
  .slick-next {
    right: 0px !important;
    z-index: 2;
  }
  .slick-slide {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  &.middle {
    width: 100%;
    height: fit-content;
  }
  .carouselItem {
    width: 100%;
    max-height: 432px;
    object-fit: contain;
    @media (max-width: 698px) {
      max-height: 354px;
    }
  }
`

export const ThumbnailStepContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-items: center;
  width: 100%;
  #colorGradient {
    height: 20px;
    width: 100%;
    max-width: 160px;
    margin-inline: 8px;
    border-radius: 25px;
    background: linear-gradient(90deg, #ED1212 0%, #FD9A05 25%, 
      #FFE203 40.87%, #2DCF08 57.69%, #02CEDD 81.73%, #0044FD 100%);
  }
  #label {
    color: #000;
    font-family: "Avenir Next";
    font-size: 14px;
    font-weight: 500;
    @media (max-width: 698px) {
      font-size: 12px;
    }
    @media (max-width: 340px) {
      font-size: 10px;
    }
  }
  #compressionMap {
    display: flex;
    align-items: center;
    .ant-switch-checked {
      background: #34C759;
    }
    #label {
      margin-left: 8px;
    }
    @media (max-width: 698px) {
      flex-flow: column;
      max-width: 74px;
      text-align: center;
      #label {
        margin-left: unset;
      }
    }
  }
`

export const ThumbnailStep = styled.div`
  width: 590px;
  height: 620px;
  object-fit: cover;
  background: url(${({ url }: DivProps) => url});
  background-size: ${({ secondary }: DivProps) => secondary ? '112%' : '140%'};
  background-repeat: no-repeat;
  background-position: center center;
  background-position-y: ${({ third }: DivProps) => third ? '-420px' : '-150px'};;
  @media (max-width: 698px) {
    width: 92vw;
    height: 70vh;
    background-position-y: ${({ third }: DivProps) => third ? '-258px' : '-100px'};;
    background-size: ${({ secondary }: DivProps) => secondary ? '70vh' : '80vh'};
  }
`

export const FitPreferenceTextContainer = styled.div`
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`

export const FitPreferenceText = styled.div`
  font-size: 20px;
  color: ${BLACK_BG};
`

export const FitPreferences = styled.div`
  display: flex;
  margin-top: 12px;
  &:last-child {
    margin-right: none;
  }
  @media (min-width: 320px) and (max-width: 768px) {
    flex-wrap: nowrap;
    width: 100vw;
    padding-inline: 12px;
    -webkit-overflow-scrolling: touch; /* smooth scroll on mobile */
    .slick-slider {
      height: 278px;
    }
    .slick-track {
      height: 100%;
    }
    .slick-arrow {
      background: white;
      border-radius: 25px;
    }
    .slick-next:before, .slick-prev:before {
      color: #375886;
      opacity: 1;
      line-height: 1.1;
    }
  }
`

export const FitCard = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  width: 240px;
  max-height: 338px; /* or any fixed height */
  margin-right: 12px;
  &:last-child {
    margin-right: none;
  }
  background: #e2e1e1;
  border-radius: 8px;
  color: #5f6062;
  cursor: pointer;
  text-align: center;
  transition: border .2s, outline .15s;
  border: ${({ secondary }: DivProps) => secondary ? '3.5px solid #34C759' : '1px solid #B3B3B3'};
  &:hover {
    outline: 2px solid #7bd090;
  }
  @media (max-width: 698px) {
    flex: 0 0 192px;
    max-height: 282px;
    margin-right: 10px;
    margin-bottom: 12px;
    margin-top: 0px;
    width: 200px !important;
  }
`

export const FitImage = styled.div`
  width: 100%;
  min-height: 200px;
  max-height: 234px;
  object-fit: cover;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background: url(${({ url }: DivProps) => url});
  background-size: ${({ secondary }: DivProps) => secondary ? '83%' : '112%'};
  background-position: center center;
  background-position-y: ${({ third }: DivProps) => third ? '-128px' : '-42px'};
  @media (max-width: 698px) {
    max-height: 152px;
    background-position-y: ${({ third }: DivProps) => third ? '-118px' : '-42px'};
    background-size: ${({ secondary }: DivProps) => secondary ? '104%' : '136%'};
  }
`

export const FitVideo = styled.video`
  width: 100%;
  max-height: 100vh;
  object-fit: cover;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  @media (max-width: 698px) {
    max-height: 152px;
  }
`

export const LoadingImage = styled.div`
  position: absolute;
  z-index: 2;
  background: #ffffff63;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
`

export const ZoomIconContainer = styled.img`
  position: absolute;
  top: 14px;
  right: 16px;
  filter: drop-shadow(0px 0px 2px white);
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 698px) {
    width: 44px;
    height: 44px;
    padding: 12px;
    top: 0px;
    right: 0px;
  }
`

export const FitTitle = styled.div`
  margin-top: 6px;
  color: #000000;
  font-weight: bold;
  text-align: center;
  border-radius: 4px;
  background: #f7f7f7;
  width: 150px;
  margin: 8px auto;
  padding: 4px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.modal {
    margin-top: 6px;
  }
`

export const FitDescription = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  padding: 4px 8px;
  &.modal {
    margin-top: 8px;
    padding-bottom: 6px;
  }
`

export const CloseFitCardIcon = styled(Icon)`
  position: absolute;
  right: -7px;
  top: -7px;
  border: 1px solid white;
  background: ${BLACK_BG};
  color: white;
  border-radius: 25px;
  padding: 4px;
  font-size: 12px;
  z-index: 2;
  &:hover {
    cursor: pointer;
  }
`

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 22px;
  #maxChar {
    width: 100%;
    color: gray;
    font-style: italic;
    padding-left: 10px;
    @media (max-width: 320px) {
      order: 1;
    }
  }
  @media (min-width: 320px) and (max-width: 768px) {
    flex-direction: column;
    margin-top: 10px;
    padding-bottom: 100px;
  } 
`

export const DesignNotes = styled(TextArea)`
  min-width: 390px;
  margin-top: 6px;
  outline: none;
  box-shadow: none;
  background: ${WHITE};
  border: 1px solid #302628;
  color: #8f8889;
  &::placeholder {
    position: relative;
    max-width: 528px;
  }
  &:hover {
    border-color: cornflowerblue;
    box-shadow: none;
  }
  &:focus {
    box-shadow: none;
  }
  @media (width > 400px) and (width <= 768px) {
    min-width: 290px;
  }
  @media (max-width: 698px) {
    font-size: 16px;
  }
  @media (width < 400px) {
    min-width: unset;
    width: 96%;
    margin: 18px auto 12px auto;
    font-size: 14px;
  }
`

export const ActionButton = styled.div`
  background: ${({ secondary }: DivProps) => secondary ? '#D7D1D2' : BLACK_BG};
  font-weight: 500;
  font-family: Avenir;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 146px;
  height: 40px;
  border-radius: 25px;
  text-align: center;
  transition: all 0.25s;
  color: ${({ secondary }: DivProps) => secondary ? '#8F8889' : 'white'};
  &[data-full="true"] {
    @media (max-width: 698px) {
      width: 100%;
    }
  }
  &.close {
    background: white;
    border: 1px solid ${BLACK_BG};
    color: ${BLACK_BG};
    padding: 7px;
    width: 144px;
  }
  &:hover {
    cursor: pointer;
    box-shadow: 0px 1px 6px 0px #484848;
  }
  @media (max-width: 698px) {
    width: 130px;
  }
  .carousel-bottom-actions > &.close {
    @media (max-width: 320px) {
      width: 110px;
    }
  }
`

export const CardFit = styled.div`
  width: 320px;
  box-shadow: 1px 2px 6px -1px #454545;
  border-radius: 5px;
  display: flex;
  font-family: Avenir;
  margin-bottom: 12px;
  background: white;
  color: #5f6062;
  justify-content: center;
  opacity: ${({ secondary }: DivProps) => (secondary ? '1' : '0.86')};
  transition: all 0.25s;
  @media (max-width: 768px) {
    width: 340px;
  }
  @media (max-width: 320px) {
    width: 300px;
  }
  &:last-child {
    @media (min-width: 768px) {
      margin-right: 0px;
    }
  }
  .hoverable {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
  .slct {
    border: 1px solid #FFFFFF;
    color: #FFFFFF;
    padding: 11px 66px;
    border-radius: 25px;
    background: #30262859;
    font-weight: 500;
    font-size: 16px;
  }
  @media (min-width: 767px) {
    &:hover {
      opacity: 1;
      cursor: pointer;
      outline: 3px solid #34C759;
      .hoverable {
        display: flex;
      }
    }
  }
  &.selected {
    opacity: 1;
    cursor: pointer;
    outline: 3px solid #34C759;
    .hoverable {
      display: flex; /* Only visible on desktop */
    }
  }
`

export const CardFitContainer = styled.div`
  padding-top: 1px;
  position: relative;
  max-width: 418px;
  @media (max-width: 768px) {
    width: 85vw;
  }
`

export const TopLabel = styled.div`
  width: 100%;
  background: #f7f7f7;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 6px;
  padding: 6px;
`

export const TopLabelItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 10px;
  min-width: 86px;
`

export const GenderButtons = styled.div`
  width: fit-content;
  display: flex;
  margin-left: 4px;
  width: 74px;
  height: 36px;
  position: absolute;
  bottom: 16px;
  right: 10px;
  font-size: 18px;
  border: 1px solid #000;
  border-radius: 18px;
  &:last-child {
    margin-left: none;
  }
  @media (max-width: 698px) {
    top: unset;
    right: unset;
    bottom: 20px;
    left: 8px;
  }
  @media (max-width: 320px) {
    left: 0px;
    transform: rotate(89deg);
    bottom: 36px;
    width: 70px;
  }
`

export const MaleButton = styled(Icon)`
  color: #2196f3;
  width: 34px;
  height: 34px;
  ${({ secondary }: DivProps) =>
    secondary
      ? `
      background: #000;
  `
      : ''}
  border-radius: 17px;
  padding: 8px;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  @media (max-width: 320px) {
    transform: rotate(-90deg)
  }
`

export const FemaleButton = styled(Icon)`
  color: deeppink;
  width: 34px;
  height: 34px;
  ${({ secondary }: DivProps) =>
    secondary
      ? `
      background: #000;
  `
      : ''}
  border-radius: 17px;
  padding: 8px;
  .anticon svg {
    display: inline-block;
    padding-top: 12px;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  @media (max-width: 320px) {
    transform: rotate(-90deg)
  }
`

export const DesignSelectedItemContainer = styled.div`
  width: 164px;
  margin-right: 14px;
  background-color: #fdfdfd;
  display: flex;
  flex-direction: column;
  margin-top: 4px;
  margin-bottom: 4px;
  align-items: center;
  position: relative;
  padding: 1px 0px 6px;
  border-radius: 5px;
  box-shadow: 1px 4px 4px 0 rgba(0, 0, 0, 0.25);
  .remover {
    position: absolute;
    right: 8px;
    top: 8px;
    color: white;
    :hover {
      cursor: pointer;
      color: red;
    }
  }
  @media (max-width: 320px) {
    width: 138px;
    height: 200px;
    margin: 0;
  }
`

export const DesignThumbnail = styled.img`
  width: 100%;
  height: 186px;
  object-fit: cover;
  background: #dedede;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`

export const DesignProductName = styled.span`
  display: block;
  font-size: 12px;
  margin-top: 8px;
  font-family: "Avenir Next";
  color: #000;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.1px;
`

export const DesignName = styled.span`
  display: block;
  font-family: "Avenir Next";
  font-weight: 400;
  font-size: 12px;
  color: black;
  line-height: 16px;
  letter-spacing: 0.1px;
`

export const DesignsContainer = styled.div`
  width: 100%;
  padding: 20px 0px;
  display: flex;
  justify-content: center;
  margin-left: 14px;
  flex-wrap: wrap;
  max-width: 1000px;
  overflow-y: auto;
  flex: 1 1 auto;
  &:last-child {
    margin-left: none;
  }
  @media (max-width: 698px) {
    margin-left: unset;
  }
  .overlay {
    position: absolute;
    background: #f7f7f7b5;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    font-weight: bold;
    padding-inline: 8px;
  }
`

export const DesignItem = styled.div`
  position: relative;
  width: 184px;
  min-height: 244px;
  border-radius: 6px;
  border: 1px solid rgb(215, 209, 210);
  background-color: rgb(247, 247, 247);
  margin-right: 14px;
  margin-bottom: 24px;
  @media (max-width: 698px) {
    margin-right: 8px;
  }
  @media (max-width: 320px) {
    margin-right: 8px;
    width: 152px;
    margin-bottom: 8px;
  }
  .design-item-layer {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border: 3px solid #34c759;
    overflow: clip;
    border-radius: 6px;
    background: #ffffffa1;
  }
  .hoverable {
    display: none;
    svg {
      transform: translateY(-28px);
    }
  }
  &:hover {
    cursor: pointer;
    .hoverable {
      display: flex;
    }
  }
  .checkIcon {
    background: #34c759;
    color: black;
    padding: 10px;
    border-radius: 25px;
    font-size: 22px;
  }
  .quickView {
    position: absolute;
    top: 6px;
    left: 8px;
    z-index: 1;
    transition: all 0.25s ease;
  }
  .quickIcon {
    max-width: 17px;
    transition: all 0.25s;
    background: #f1f4f561;
    border-radius: 25px;
    &:hover {
      cursor: pointer;
      filter: brightness(1) drop-shadow(0px 0px 1px gray);
    }
  }
  .design-info-container {
    padding: 0 8px;
    display: flex;
    flex-flow: column;
    margin-block: 4px;
  }
  .design-info-name {
    color: #000;
    font-family: "Avenir Next";
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 14px;
    letter-spacing: 0.1px;
  }
  .design-info-code {
    color: #000;
    font-family: "Avenir Next";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0.1px;
  }
  .imgItem {
    width: 100%;
    object-fit: contain;
    padding: 16px;
  }
  ${({ secondary }: DivProps) => secondary ? `
    min-height: 234px;
    .imgItem {
      padding: 0 0 4px;
      border-radius: 5px 5px;
    }
    .design-info-name {
      font-weight: normal;
    }
    .design-info-code {
      font-weight: 600;
    }
  ` : ''}
`

export const RecSizeSelectionContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  background: ${WHITE};
  position: sticky;
  width: 100%;
  top: 78px;
  z-index: 2;
  @media (max-width: 698px) {
    top: 0px;
  }
  #size-rec-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 20px;
    @media (max-width: 698px) {
      display: none;
    }
  }
  #size-rec-header-mobile {
    display: none;
    @media (max-width: 698px) {
      margin-top: 22px;
      display: block;
    }
  }
  #counterContainerWrapper {
    padding-top: 20px;
    display: flex;
    align-items: center;
    margin-left: 12px;
    position: relative;
    &:last-child {
      margin-left: none;
    }
    @media (max-width: 698px) {
      display: none;
    }
  }
  .container > div:last-child {
    border-bottom: none;
  }
  #counterContainer {
    padding-top: 20px;
    display: flex;
    align-items: center;
    position: absolute;
    top: 40%;
    left: -148px;
    &:last-child {
      margin-left: none;
    }
  }
  #counterLabel {
    color: #302628;
    font-family: "Avenir Next";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0.2px;
  }
  #counter {
    display: flex;
    width: 30px;
    height: 30px;
    padding: 8px 9px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 15px;
    background: #34c759;
    margin-left: 12px;
  }
  #titleLabel {
    color: #302628;
    text-align: center;
    font-family: "Avenir Next";
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.1px;
    margin: auto 116px;
    @media (max-width: 698px) {
      font-size: 14px;
      margin: auto;
    }
  }
  #designCntrWrapper {
    min-width: 917px;
    display: flex;
    align-items: center;
    border-radius: 10px;
    border: 1px solid rgb(179, 179, 179);
    background: rgb(255, 255, 255);
  }
  ${({ secondary }: DivProps) => secondary ? `
    height: 70px;
    #counterContainerWrapper {
      display: none;
    }
  ` : ''};
`

export const CollapseMobile = styled(Collapse)`
  width: 100%;
  display: none;
  flex-direction: column;
  & > .ant-collapse-item > .ant-collapse-header {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0px;
    border-radius: 0px;
    .ant-collapse-item {
      padding: 4px 0 4px 0px;
    }
  }
  & > .ant-collapse-item > .ant-collapse-header > .arrow {
    margin-left: auto;
    left: unset;
    right: 0px;
  }
  & > .ant-collapse-item > .ant-collapse-content {
    border: none;
  }
  & > .ant-collapse-item:last-child {
    border-radius: 0px;
  }
  @media (max-width: 698px) {
    display: flex;
  }
  .ant-collapse-arrow {
    order: 2;
  }
`

export const PanelMobile = styled(Collapse.Panel)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 16px 6px 16px;
  border-bottom: 1px solid #D7D1D2;
  background: #F7F7F7;
  color: #302628;
  font-family: "Avenir Next";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.1px;
`

export const SizeRecDesignContainer = styled.div`
  display: flex;
  margin-left: 12px;
  padding-left: 10px;
  margin-block: 12px;
  &:last-child {
    margin-left: none;
  }
`

export const DesignItemContinueAction = styled.div<{ visibility?: boolean }>`
  color: ${(props) => (props.visibility ? '#FFF' : '#8F8889')};
  background-color: ${(props) => (props.visibility ? '#302628' : '#D7D1D2')};
  border-radius: 25px;
  width: 144px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 14px;
  &:hover {
    cursor: ${(props) => (props.visibility ? 'pointer' : 'not-allowed')};
    opacity: 0.7;
  }
`

export const DesignItemCancelAction = styled.div`
  width: 144px;
  height: 40px;
  color: #302628;
  border: 1px solid #131112;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  line-height: normal;
  font-size: 14px;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const CollapseButton = styled(Icon)`
  position: absolute;
  bottom: -12px;
  background: white;
  border-radius: 50%;
  padding: 6px;
  z-index: 2;
  box-shadow: 0px 2px 3px -1px #717171;
  font-size: 12px;
  color: #626262;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 698px) {
    display: none;
  }
`

export const StyledInput = styled(Input)`
  width: 94%;
  max-width: 400px;
  margin-top: 10px;
  .ant-input {
    border-radius: 25px;
  }
  .ant-input:focus {
    box-shadow: unset;
    border-color: cornflowerblue !important;
  }
  .ant-input-suffix {
    z-index: 1;
  }
  &:hover {
    .ant-input {
      border-color: cornflowerblue !important;
    }
  }
`

export const SearchButton = styled.div`
  margin-right: -9px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 26px;
  border-radius: 25px;
  background-color: white;
  border: 1px solid ${BLACK_BG};
  color: ${BLACK_BG};
  font-size: 12px;
  &:hover {
    background-color: ${BLACK_BG};
    color: white;
    cursor: pointer;
  }
`

export const Step = styled.div`
  background: #eeeeee;
  color: #302628;
  font-family: "Avenir Next";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
  width: 146px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1.5px solid #ffffff;
  transition: all 0.25s;
  &:last-child {
    border-right: none;
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
  }
  &:first-child {
    border-left: none;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
  }
  ${({ secondary }: DivProps) =>
    secondary
      ? `
    background: #34C759;
    color: #312E2E;
    font-weight: 600;
  `
      : ''}
`
export const HowToMeasureContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-block: 24px;
  h1 {
    color: #302628;
    text-align: center;
    font-family: "Avenir Next";
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  @media (max-width: 698px) {
    padding: 0 30px 60px;
    width: 100%;
    h1 {
      max-width: 258px;
      margin: 0 auto;
    }
  }
`

export const ChecklistContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: fit-content;
  font-family: "Avenir Next";
`

// Container for the check list cards (flex row, each card is 50%)
export const ChecklistRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
  width: 100%;
  justify-content: space-between;
  > div {
    flex-basis: 48%;
  }
  > div:nth-child(2) {
    margin-left: 32px;
  }
  @media (max-width: 900px) {
    flex-direction: column;
    > div {
      flex-basis: 100%;
      margin-left: 0 !important;
      @media (max-width: 320px) {
        margin-inline: 8px !important;
      }
    }
  }
`

// Each checklist card takes 50% (minus margin for gap)
export const ChecklistCard = styled.div`
  padding-inline: 22px;
  display: flex;
  flex-direction: column;
  min-width: 260px;
  max-width: 408px;
  width: 100%;
  min-height: 548px;
  position: relative;
  align-items: flex-start;
  flex-shrink: 0;
  margin-bottom: 24px;
  border-radius: 20px;
  border: 2px solid #E8E5E5;
  background: #FFF;
  font-family: "Avenir Next";
  &[data-min-height="none"] {
    min-height: unset;
    max-width: 386px;
    padding-inline: unset;
    cursor: pointer;
  }
  &[data-checked="true"] {
     border: 3px solid #34c759;
  }
  &[data-has-error="true"] {
    border: 3px solid red;
  }
  @media (max-width: 698px) {
    max-width: 95%;
  }
  @media (max-width: 320px) {
    min-height: 466px;
  }
  @media (max-height: 832px) {
    min-height: fit-content;
  }
`

export const ChecklistHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 56px;
  padding-inline: 22px;
`

export const ChecklistSubtitle = styled.div`
  color: #817E7E;
  font-family: "Avenir Next";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  border-top: 1px solid #D7D1D2;
  background: #FFF;
  span {
    display: block;
    margin-block: 10px;
    margin-inline: 16px;
  }
`

// Step indicator circle at the top left with number inside
export const StepIndicator = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #302628;
  color: #FFF;
  font-family: "Avenir Next";
  font-size: 12px;
  font-weight: 700;
  &.secondary {
    width: 80%;
    border-radius: 25px;
    margin-bottom: 14px;
    font-weight: normal;
    height: 44px;
    font-size: 14px;
  }
  &[data-bg="none"] {
    background: none;
    color: #000;
    font-size: 28px;
  }
`

export const ChecklistTitle = styled.div`
  margin-left: 12px;
  line-height: 28px;
  text-align: left;
  text-transform: uppercase;
  color: #8F8889;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  &[data-color-black] {
    color: #000;
  }
`

// Card main image
export const ChecklistImage = styled.img`
  height: 307px;
  flex-shrink: 0;
  align-self: stretch;
  object-fit: cover;
  margin-inline: -22px;
  &[data-bottom-rounded="true"] {
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    height: 316px;
    margin-inline: 0px;
  }
  @media (max-width: 698px) {
    height: 264px !important;;
  }
  @media (max-height: 832px) {
    height: 290px;
  }
`

// List of todo/check items below the image
export const ChecklistTodos = styled.ul`
  list-style: none;
  padding: 0;
  margin: 20px 0 2px 0;
  @media (max-width: 320px) {
    margin: 16px 0 10px 0;
  }
  @media (max-height: 832px) {
    margin: 12px 0 2px -6px;
  }
`

export const ChecklistTodoItem = styled.li`
  padding-left: 0px;
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
  color: #625F5F;
  font-weight: 400;
  line-height: 18.2px;
  @media (max-width: 320px) {
    font-size: 13px;
    margin-left: -10px;
  }
  @media (max-height: 832px) {
    margin-bottom: 8px;
  }
  &:before {
    content: '✓';
    display: inline-flex;
    height: 18px;
    margin-right: 8px;
    padding: 2px 4.83px 2px 5.17px;
    justify-content: center;
    align-items: center;
    border-radius: 9px;
    background: rgba(22, 163, 74, 0.10);
    color:  #34C759;
    font-family: "Lucida Grande";
    font-size: 10px;
    font-weight: 600;
    line-height: 14px; /* 140% */
  }
`

// Footer with custom styled checkbox and label
export const ChecklistFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: auto;
  padding-inline: 22px;
  border-top: 1px solid #ececec;
  width: calc(100% + 44px);
  height: 56px;
  margin-inline: -22px;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
  &[data-checked="true"] {
    background: #34c759;
    border-color: #34c759;
  }
  &[data-has-error="true"] {
    background: red;
    border-color: red;
  }
  @media (max-height: 832px) {
    height: 52px;
    margin-top: 0px;
  }
`

export const ChecklistCheckbox = styled.input.attrs({ type: 'checkbox' })`
  accent-color: #34c759;
  width: 22px;
  height: 22px;
  margin-left: 2px;
  margin-right: 12px;
  cursor: pointer;
  position: relative;

  appearance: none; /* Remove default checkbox styles */
  -webkit-appearance: none;
  border-radius: 7px;
  border: 2px solid #D1D5DB;
  background: #FFF;

  /* When checked, fill with green */
  &:checked {
    background: #34c759;
    border-color: #34c759;
  }
`

export const ChecklistCheckboxWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`

export const ChecklistCheckboxIcon = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  .anticon {
    font-size: 16px;
    color: #302628;
  }
`

export const ChecklistCheckboxLabel = styled.label`
  font-size: 15px;
  user-select: none;
  cursor: pointer;
  color: #302628;
  font-size: 16px;
  font-weight: 600;
`

export const ChecklistFootnote = styled.div`
  color: #A8A0A1;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  margin-top: -18px;
  margin-bottom: 20px;
  @media (max-width: 698px) {
    margin-inline: 22px !important;
    margin-top: 0px;
  }
  @media (max-width: 320px) {
    font-size: 12px;
    margin-inline: 10px !important;
  }
  @media (max-height: 832px) {
    margin-top: -12px;
  }
`

export const FlexDiv = styled.div`
  display: flex;
  .bottom-actions-container {
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
  .actions-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  &.section-footer {
    position: fixed;
    bottom: 0;
    background: white;
    padding: 8px 12px;
    width: 676px;
    justify-content: space-between;
    @media (max-width: 698px) {
      width: 90%;
      margin-top: 70px;
    }
    /* Set only fixed only when using desktop and min-height */
    @media  (min-width: 768px) and (min-height: 780px) {
      position: unset;
    }
  }
  @media (max-width: 698px) {
    margin-inline: 16px;
  }
`
export const UnitsToggle = styled.div`
  display: flex;
  align-items: center;
  margin: 12px 0 18px;
  @media (max-width: 768px) {
    width: 90%;
  }

  .unitsLabel {
    color: #7F7F7F;
    font-weight: 600;
    font-size: 10px;
    margin-right: 18px;
    color: #625F5F;
    letter-spacing: 0.75px;
    text-transform: uppercase;
  }

  .switchPill {
    position: relative;
    display: inline-flex;
    align-items: center;
    background: #E2E0E0;
    border-radius: 100px;
    padding: 4px;
    height: 40px;
    user-select: none;
  }

  .opt {
    position: relative;
    z-index: 2;
    padding: 0 28px;
    width: 100%;
    text-align: center;
    line-height: 32px;
    font-size: 12px;
    font-weight: 600;
    color: #817E7E;
    pointer-events: none;
    transition: color 0.2s ease;
    &.active {
      color: #302628;
      font-weight: 600;
    }
  }

  .ant-switch {
    position: absolute;
    top: 4px;
    left: 4px;
    width: calc(100% - 8px);
    height: calc(100% - 8px);
    min-width: 0;
    background: transparent;
    border: none;
    border-radius: 100px;
    box-shadow: none;

    &:focus {
      box-shadow: none;
    }

    &::after {
      top: 0;
      left: 0;
      width: calc(50% - 2px);
      height: 100%;
      margin-left: 0;
      border-radius: 100px;
      background: #FFFFFF;
      box-shadow: 0 2px 6px #0000001f;
    }

    &.ant-switch-checked {
      background: transparent;
      &::after {
        left: 50%;
        margin-left: 50%;
      }
    }
  }

  @media (max-width: 768px) {
    .unitsLabel {
      display: none;
    }
    .switchPill {
      flex: 1;
      display: flex;
      justify-content: space-between;
    }
  }

  @media (max-width: 340px) {
    margin-right: 10px;
    .opt {
      padding: 0 18px;
      font-size: 13px;
    }
  }
`

const selectFieldStyles = `
  appearance: none;
  width: 100%;
  padding: 12px 44px 12px 18px;
  border: 1px solid #D9D9D9;
  border-radius: 10px;
  background-color: #FFFFFF;
  font-size: 14px;
  color: #111;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #B8B8B8;
  }
  &:focus {
    outline: none;
    border-color: #111;
  }
  &:invalid {
    color: #817E7E;
  }
  &[data-has-error="true"] {
    border-color: red;
  }
  option {
    color: #111;
  }
  option:disabled {
    color: #9B9B9B;
  }
`

export const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 8px;

  select {
    ${selectFieldStyles}
  }

  > .anticon {
    position: absolute;
    right: 16px;
    pointer-events: none;
    color: #302628;
    font-size: 12px;
  }
`

export const ManualFieldsGrid = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding-top: 24px;
  margin-top: 24px;
  border-top: 2px solid #E5E5E5;

  .field {
    display: flex;
    flex-direction: column;
    flex: 1 1 calc((100% - 48px) / 3);
    min-width: 164px;
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
    @media (max-width: 698px) {
      margin-right: 0;
    }
  }

  .fieldLabel {
    color: #625F5F;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.75px;
    text-transform: uppercase;
    @media (max-width: 768px) {
      font-size: 10px;
      letter-spacing: 0.75px;
    }
  }

  .fieldLabelUnit {
    display: none;
    @media (max-width: 768px) {
      display: inline-flex;
      margin-left: 4px;
      color: #625F5F;
      font-size: 10px;
      font-weight: 600;
      letter-spacing: 0.75px;
      text-transform: uppercase;
    }
  }

  select {
    ${selectFieldStyles}
  }

  @media (max-width: 698px) {
    padding-top: 0;
    margin-top: 0;
    border-top: unset;
    flex-wrap: nowrap;
    .field {
      flex: 1 1 0;
      min-width: 0;
      margin-right: 8px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
`

export const BodyMeasurementsSection = styled.div`
  width: 100%;
  padding-top: 28px;
  margin-top: 28px;
  border-top: 2px solid #E5E5E5;

  .sectionTitle {
    color: #625F5F;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.75px;
    text-transform: uppercase;
  }

  .sectionSubtitle {
    color: #817E7E;
    font-size: 14px;
    font-weight: 400;
    margin-top: 10px;
    line-height: 21px;
    .bold {
      font-weight: 600;
      color: #302628;
    }
  }

  .grid {
    display: flex;
    flex-wrap: wrap;
    margin-top: 28px;
  }

  .field {
    display: flex;
    flex-direction: column;
    flex: 1 1 calc((100% - 32px) / 2);
    min-width: 240px;
    margin-right: 22px;
    margin-bottom: 28px;
    &:nth-child(even) {
      margin-right: 0;
    }
    &:nth-last-child(-n+2) {
      margin-bottom: 0;
    }
    @media (max-width: 768px) {
      border-radius: 8px;
      border: 1px solid #E8E5E5;
      background: #FFF;
      padding: 16px;
    }
  }

  .fieldHead {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .fieldLabelUnit {
    display: none;
    @media (max-width: 768px) {
      display: inline-flex;
      margin-left: 4px;
      color: #302628;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
    }
  }

  .ant-tooltip-inner {
    background-color: transparent;
    color: inherit;
    padding: 0;
    border-radius: 0;
    box-shadow: none;
    min-width: 0;
    min-height: 0;
  }

  .ant-tooltip-arrow {
    display: none;
  }

  .fieldLabel {
    color: #302628;;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px; 
  }

  .howToLink {
    display: inline-flex;
    align-items: center;
    color: #34C759;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.3px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    transition: color 0.2s ease;

    &:hover {
      color: #148A48;
      text-decoration: underline;
    }

    .anticon {
      font-size: 14px;
      color: inherit;
      margin-right: 6px;
    }
  }

  select {
    ${selectFieldStyles}
  }

  @media (max-width: 698px) {
    padding-top: 18px;
    margin-top: 20px;
    .grid {
      margin-top: 20px;
    }
    .field {
      flex: 1 1 100%;
      min-width: 0;
      margin-right: 0;
      margin-bottom: 0;
      margin-top: 20px;
      &:first-child {
        margin-top: 0;
      }
    }
    .fieldHead {
      flex-wrap: wrap;
    }
    .howToLink {
      margin-top: 14px;
      align-self: flex-end;
    }
  }
`

export const GuideTooltipContent = styled.div`
  border-radius: 8px;
  min-width: 434px;
  height: 180px;
`

export const GuideTooltipImage = styled.img`
  display: block;
  width: 434px;
  max-width: 100%;
  height: 182px;
`

export const ManualStep = styled.div`
  max-width: 532px;
  #manualTitle {
    text-align: center;
    margin-block: 38px 20px;
    color: #111;
    font-size: 22px;
    font-weight: 600;
    line-height: 30.8px;
  }
  .inputs {
    width: 100%;
    background: #F7F7F7;
    padding: 20px 30px;
    border-radius: 8px;
  }
  #measureLink {
    flex: 1;
    text-decoration: underline;
    font-weight: 500;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    cursor: pointer;
  }
  @media (max-width: 698px) {
    #warningManual {
      flex-flow: column;
      margin: 12px 22px;
    }
    #inputSection {
      flex-flow: column;
      align-items: center;
      background: #f7f7f7;
      padding-bottom: 14px;
    }
    #manualPhoto {
      margin-top: 10px;
    }
    #manualTitle {
      margin-block: 16px;
    }
    .inputs {
      width: unset;
      padding: unset;
    }
  }
  @media (max-width: 340px) {
    #manualTitle {
      font-size: 16px;
      margin-inline: 6px;
    }
  }
`

export const ModalComponent = styled(Modal)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw !important;
  max-width: unset !important; /* Remove default max-width */
  padding: 0; /* Remove default padding if desired */
  margin: 38px 0px 0px 0px !important;
  @media (max-width: 320px) {
    &.fit-step {
      margin-top: 0px !important; /* Set modal full height when displaying fit stage */
    }
  }
  .ant-modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .ant-modal-body {
    flex-grow: 1; /* Allow body to take available space */
    overflow: auto; /* Add scroll if content exceeds screen height */
    padding: 0 !important;
  }
`

export const ExistingSizeRecContainer = styled.div`
  color: #302628;
  font-family: Avenir;
  font-size: 16px;
  line-height: 24px;
  margin-left: -32px;
  margin-right: 6px;
  padding: 20px;
  #existing-size-rec-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px; /* 140% */
    @media (max-width: 320px) {
      font-size: 15px;
      line-height: 20px; /* 140% */
    }
  }
  #existing-size-rec-summary {
    margin-top: 24px;
    font-weight: 400;
    @media (max-width: 320px) {
      margin-top: 20px;
      font-size: 14px;
    }
  }
  .existing-size-rec-or {
    margin-left: 2px;
  }
  #existing-size-rec-items-container {
    margin-top: 24px;
    padding: 18px 24px;
    background: #ffc5c5;
    color: #5F6062;
    font-style: italic;
  }
  ul {
    margin-top: 6px;
    padding-inline-start: 26px;
    &>li::marker {
      font-size: 20px;
      @media (max-width: 320px) {
        font-size: 14px;
      }
    }
    @media (max-width: 320px) {
      padding-inline-start: 6px;
      font-size: 14px;
    }
  }
`

export const SuccessScreen = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  text-align: center;
  margin-top: 144px;
  font-family: Avenir;
  @media (max-width: 698px) {
    margin-left: 20px;
    margin-right: 20px;
  }
  @media (max-width: 320px) {
    margin-top: 60px;
    margin-left: 12px;
    margin-right: 12px;
  }
  #successBtns {
    margin-top: 100px;
    width: 100%;
    justify-content: flex-end;
    &[data-done="true"] {
      @media (max-width: 698px) {
        margin-top: 60px;
        justify-content: center;
      }
    }
    @media (max-width: 320px) {
      margin-top: 70px;
    }
  }
  #submitTitle {
    font-size: 28px;
    font-weight: 600;
    color: #000;
    margin-block: 34px -6px;
    @media (max-width: 698px) {
      margin-left: 24px;
      margin-right: 24px;
      font-size: 22px;
    }
    @media (max-width: 320px) {
      font-size: 18px;
      margin-left: 0px;
      margin-right: 0px;
    }
  }
  #submitMsg {
    color: #000;
    font-size: 20px;
    font-weight: 500;
    margin-block: 12px 20px;
    @media (max-width: 698px) {
      font-size: 16px;
      font-weight: 400;
      margin-block: 40px 0px;
      margin-inline: 8px;
    }
    @media (max-width: 320px) {
      font-size: 14px;
      margin-left: 0px;
      margin-right: 0px;
    }
  }
  #unconfirmedMsg {
    max-width: 416px;
    color: #000;
    font-size: 20px;
    font-weight: 500;
    margin-block: 12px 20px;
    span {
      font-size: 14px;
      color: #302628;
      margin-block: 28px;
      display: block;
    }
  }
  #submitNote {
    font-size: 14px;
    color: #625F5F;
    margin-top: 78px;
    @media (max-width: 698px) {
      margin-top: 40px;
      margin-inline: 4px;
    }
  }
  #manualBtn {
    margin-top: 8px;
    text-decoration: underline;
    font-weight: bold;
    &:hover {
      cursor: pointer;
    }
  }
`

export const MeasureOptionContainer = styled.div`
  margin-top: 82px;
  display: flex;
  flex: 1;
  flex-direction: column;
  .measure-overdue-mobile {
    display: none;
    @media (max-width: 698px) {
      display: block;
      color: #C91731;
      margin-bottom: 12px;
    } 
  }
  .measure-overdue {
    margin: 4px auto;
    display: flex;
    flex-direction: column;
    color: #c91731;
    font-family: "Avenir Next";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    @media (max-width: 698px) {
      display: none;
    }
  }
  .measurement-new-profile {
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 316px;
    @media (max-width: 698px) {
      justify-content: start;
    }
    &.create-new-mobile {
      min-height: 0px;
    }
  }
  .measured-head {
    color: #000;
    text-align: center;
    font-family: "Avenir Next";
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 4px 20px;
    @media (max-width: 698px) {
      font-size: 16px;
    }
  }
  .measured-head.or {
    color: #817E7E;
  }
  .measured-head-mobile {
    display: none;
    @media (max-width: 698px) {
      display: block;
      color: #000;
    }
  }
  .measurement-new-profile.measured-new-profile {
    @media (max-width: 698px) {
      display: none;
    }
  }
  .get-measured-cta {
    width: 160px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 22px;
    background: #e8e5e5;
    color: #302628;
    font-family: "Avenir Next";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .options-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: start;
    justify-items: center;
    width: 100%;
    max-width: 728px; 
    margin: 0 auto;
  }
  .card {
    max-width: 320px;
    width: 100%;
  }
  @media (max-width: 698px) {
    margin-top: 24px;
  }
`
export const MeasurementNewProfileMobile = styled.div`
  display: none;
  @media (max-width: 698px) {
    display: flex;
    justify-content: center;
    flex-direction: row;
    border-radius: 22px;
    margin-top: 6px;
    padding: 12px 24px;
    min-width: 340px;
    height: 40px;
    background: #E8E5E5;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    font-family: "Avenir Next";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    span {
      margin-right: 8px; 
    }
    @media (max-width: 320px) {
      min-width: 300px;
    }
  }
`

export const TitleModal = styled.div`
  padding: 16px 30px;
  border-bottom: 1px solid lightgray;
  margin-bottom: 16px;
  font-family: Avenir;
  font-weight: 500;
  #closeModal {
    float: right;
    font-size: 20px;
    margin-top: -2px;
    cursor: pointer;
  }
`

export const cancelButtonStyle = {
  border: '1.5px solid #302628',
  borderRadius: '25px',
  backgroundColor: 'white',
  fontWeight: 500,
  minWidth: '40%',
  fontFamily: 'Avenir',
  color: '#302628',
}

export const sizeRecButtonStyle = (isMobile: boolean) => ({
  border: '1.5px solid #302628',
  borderRadius: '25px',
  backgroundColor: 'white',
  fontWeight: 500,
  minWidth: isMobile ? 'unset' : '180px',
  fontFamily: 'Avenir',
  color: '#302628',
  width: isMobile ? '84%' : 'unset',
  height: 'fit-content',
  paddingBlock: '6px'
})

export const ManualMeasureContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-inline: 23px;
  margin-block: 20px;
  padding-inline: 24px;
  background: #F7F7F7;
  color: #000000;
  border-radius: 10px;
  font-family: Avenir;
  #header {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-block: 10px;
    @media (max-width: 698px) {
      text-align: start;
    }
  }
  a {
    color: cornflowerblue;
  }
  ul {
    padding-left: 24px;
    > li > span.underline {
      text-decoration: underline;
    }
  }
  .item {
    display: flex;
    align-items: start;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 600;
    div:first-child {
      flex-basis: 80px;
      padding-right: 10px;
      text-align: right;
    }
    div {
      flex-basis: 90%;
      font-weight: 500;
    }
  }
`

export const GuideBottomSheetTip = styled.div`
  width: 36px;
  height: 4px;
  border-radius: 2px;
  background: #D7D1D2;
  margin-top: 12px;
`

export const GuideBottomSheetImage = styled.img`
  display: block;
  width: 100%;
  max-height: 60vh;
  object-fit: contain;
  background: #fff;
  padding: 16px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SizeRecModal/styledComponents.tsx